module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Ssheader"
  }, [_c('nav', {
    staticClass: "navbar container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu navk",
    class: {
      navMenu: _vm.navMenu
    }
  }, _vm._l((_vm.menuData), function(menu) {
    return _c('router-link', {
      key: ("" + (menu.index)),
      staticClass: "navbar-item ",
      class: {
        active: menu.isActive
      },
      attrs: {
        "to": ("/" + (menu.path))
      },
      nativeOn: {
        "click": function($event) {
          _vm.navMenu = !_vm.navMenu
        }
      }
    }, [_vm._v(_vm._s(menu.name))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    on: {
      "click": function($event) {
        _vm.navMenu = !_vm.navMenu
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/sarikayaSahinLogo.png",
      "alt": "Sarıkayaşahin Hukuk"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c55e15a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/header.vue
// module id = 59
// module chunks = 0